import { Component, Inject } from '@angular/core';
import { MessageComponent, MessageType, WINDOW } from '@sfcu/sfc-front-starter';
import { BtnRetourComponent } from '../btn-retour/btn-retour.component';

@Component({
    selector: 'app-error',
    templateUrl: './technical-error.component.html',
    imports: [MessageComponent, BtnRetourComponent],
    standalone: true,
})
export class TechnicalErrorComponent {
    protected readonly MessageType = MessageType;

    constructor(@Inject(WINDOW) private window: Window) {}
}
